import { MediaQuery } from '@ga/utils'

import { breakpoints } from './breakpoints'

export const mediaQueryInstance = new MediaQuery(breakpoints)
